import materialColors from 'vuetify/es5/util/colors';

export default {
  'theme-background-app': materialColors.blueGrey.lighten5,
  primary: '#263238',
  secondary: '#fff',
  selected_tab: '#e0e0e0',
  'theme-navigation-bar-separator': '#474b5f',
  'theme-joblist-background': '#9e9e9e',
  'theme-joblist-text-color': '#9e9e9e',
  'theme-jobitem-text-color': 'black',
  badge_info: '#2196F3',
  tertiary: materialColors.blueGrey.darken3,
  box: materialColors.blueGrey.lighten5,
  accent: materialColors.blueGrey.lighten2,
  error: materialColors.red.base,
  warning: materialColors.red.base,
  info: materialColors.blue.base,
  callReceived: materialColors.blue.base,
  callAccepted: materialColors.green.base,
  callDeclined: materialColors.orange.base,
  callLost: materialColors.red.base,
  success: materialColors.green.base,
  progress: materialColors.blue.base,
  message_agent: materialColors.blueGrey.lighten4,
  message_user: materialColors.blueGrey.lighten5,
  message_default: materialColors.blueGrey.lighten5,
  'notification-info': materialColors.grey.darken4,
  'button-choice': materialColors.blue.darken2,
  'job-list-content': '#fff',
  'job-active-content': materialColors.blueGrey.darken1,
};
